import { connectHits } from 'instantsearch.js/es/connectors';

const renderHits = (renderOptions, isFirstRender) => {
    const { hits, widgetParams, results } = renderOptions;
    let themePath = $('.tematik_recettes').data('theme-path');
    let defaultImg = themePath + "/img/photos/default-img.svg";
    let baseUrl = $('.tematik_recettes').data('url');
    let pageRecetteURL = $('.tematik_recettes').data('recette');

    widgetParams.container.innerHTML = `
        ${hits.map(item => `
        <li>
        <a class="blocMedia blocMedia--carre" href="${pageRecetteURL+"/"+item.url_seo}">
            <figure class="blocMedia-media">
                <picture>
                    <source srcset="${baseUrl + item.illustration_principale.webp}" type="image/webp">
                    <img src="${item.illustration_principale.base ? baseUrl + item.illustration_principale.base : defaultImg}" alt="${item.nom}" loading="lazy" />    
                </picture>
                <span class="blocMedia-badge badge badge-pill">Recette ${item.auteur}</span>
            </figure>
            <article class="blocMedia-contenu">
                <div class="blocMedia-note">
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                </div>
                <h2 class="blocMedia-titre titre4--lowercase">${item.nom}</h2>
                <span class="blocMedia-categories">
                ${item.categorie}
                </span>
            </article>
            <div class="blocMedia-attributs">
                ${item.temps_preparation.length > 1 ?  `<span><i class="icon-clock"></i> ${item.temps_preparation} </span>` : ""}
                <span> <i class="icon-chef-top"></i> ${item.difficulte}</span>
            </div>
        </a>
    </li>`
        )
        .join('')}
    `;
  };
  
  const customHits = connectHits(renderHits);
 
  export default customHits;